export var preloadDirectory = {
    images:[
        {id:'gfx_loading' , src:'assets/letterati/ui/Containers/gfx_loading-2.png', },
        {id:'gfx_loading_bar_con' , src:'assets/letterati/ui/Containers/gfx_loading_bar_con.png', },
        {id:'lan_gen_bg' , src: 'assets/letterati/ui/Backgrounds/gen_overlay.png', },
        {id:'por_gen_bg', src: 'assets/letterati/ui/Backgrounds/gen_overlay.png', },
    ],
    json:[
        {id:'locale_en' , src: 'assets/letterati/strings/locale_en.json'},
        {id:'locale_es' , src: 'assets/letterati/strings/locale_es.json'},
    ],
    atlas:[
        {id:'gizmo' , spriteSheet: 'assets/letterati/animations/gizmo_preloader.png', json: 'assets/letterati/animations/gizmo_preloader.json'},
    ]
}

export var assetDirectory = {
    images:[
        {id:'lan_gen_bg' , src: 'assets/letterati/ui/Backgrounds/gen_overlay.png'},
        {id:'por_gen_bg' , src: 'assets/letterati/ui/Backgrounds/gen_overlay.png'},

        {id:'gfx_container', src: 'assets/letterati/ui/Containers/gfx_container.png',},
        {id:'gfx_container_white', src: 'assets/letterati/ui/Containers/gfx_container_white.png',},
        {id:'gfx_pop', src: 'assets/letterati/ui/Containers/gfx_pop.png',},
        {id:'gfx_pop2', src: 'assets/letterati/ui/Containers/gfx_pop2.png',},
        {id:'gfx_life_off', src: 'assets/letterati/ui/Containers/gfx_life_off.png',},
        {id:'gfx_life_on', src: 'assets/letterati/ui/Containers/gfx_life_on.png',},
        {id:'gfx_flare_long', src: 'assets/letterati/ui/Containers/gfx_flare_long.png',},
        {id:'gfx_flare_star', src: 'assets/letterati/ui/Containers/gfx_flare_star.png',},

        {id:'btn_play', src: 'assets/letterati/ui/Buttons/btn_play.png',},
        {id:'btn_play_pressed', src: 'assets/letterati/ui/Buttons/btn_play_pressed.png',},
        {id:'play_button', src: 'assets/letterati/ui/Buttons/btn_return.png',},
        {id:'play_button_pressed', src: 'assets/letterati/ui/Buttons/btn_return2.png',},
        {id:'mute_button', src: 'assets/letterati/ui/Buttons/btn_audio1.png',},
        {id:'mute_button_pressed', src: 'assets/letterati/ui/Buttons/btn_audio3.png',},
        {id:'unmute_button', src: 'assets/letterati/ui/Buttons/btn_audio2.png',},
        {id:'unmute_button_pressed', src: 'assets/letterati/ui/Buttons/btn_audio4.png',},
        {id:'exit_button', src: 'assets/letterati/ui/Buttons/btn_exit.png',},
        {id:'exit_button_pressed',  src: 'assets/letterati/ui/Buttons/btn_exit2.png',},
        {id:'pause_button', src: 'assets/letterati/ui/Buttons/btn_pause.png',},
        {id:'pause_button_pressed', src: 'assets/letterati/ui/Buttons/btn_pause2.png',},
        {id:'next_button', src: 'assets/letterati/ui/Buttons/btn_prevnext.png',},
        {id:'next_button_pressed', src: 'assets/letterati/ui/Buttons/btn_prevnext2.png',},
        {id:'check_button', src: 'assets/letterati/ui/Buttons/btn_check.png',},
        {id:'check_button_pressed', src: 'assets/letterati/ui/Buttons/btn_check2.png',},
        {id:'close_button', src: 'assets/letterati/ui/Buttons/btn_x.png',},
        {id:'close_button_pressed', src: 'assets/letterati/ui/Buttons/btn_x2.png',},
        {id:'skip_button', src: 'assets/letterati/ui/Buttons/btn_skip.png',},
        {id:'skip_button_pressed', src: 'assets/letterati/ui/Buttons/btn_skip2.png',},
        {id:'next_question_button', src: 'assets/letterati/ui/Buttons/btn_next.png',},
        {id:'next_question_button_pressed', src: 'assets/letterati/ui/Buttons/btn_next2.png',},

        {id:'title_glow', src: 'assets/letterati/ui/Title Screen/title_glow.png',},
        {id:'title_superbook', src: 'assets/letterati/ui/Title Screen/title_superbook.png',},
        {id:'title_la_gizmo', src: 'assets/letterati/ui/Title Screen/title_la_gizmo.png'},
        {id:'title_la_gizmo_e', src: 'assets/letterati/ui/Title Screen/title_la_gizmo_e.png'},
        {id:'title_la_gizmo_z', src: 'assets/letterati/ui/Title Screen/title_la_gizmo_z.png'},

        {id:'title_la_letter', src: 'assets/letterati/ui/Title Screen/title_la_letter.png'},
        {id:'title_la_a', src: 'assets/letterati/ui/Title Screen/title_la_a.png'},
        {id:'title_la_t', src: 'assets/letterati/ui/Title Screen/title_la_t.png'},
        {id:'title_la_i', src: 'assets/letterati/ui/Title Screen/title_la_i.png'},
        
        {id:'lan_btn_word', src: 'assets/letterati/ui/Landscape/Buttons/lan_choice.png'},
        {id:'lan_btn_word_correct', src: 'assets/letterati/ui/Landscape/Buttons/lan_choice_correct.png' },
        {id:'lan_btn_word_wrong', src: 'assets/letterati/ui/Landscape/Buttons/lan_choice_wrong.png' },
        {id:'lan_ctn_question', src: 'assets/letterati/ui/Landscape/Containers/lan_phrase.png'},
        {id:'lan_timer_bar', src: 'assets/letterati/ui/Landscape/Containers/lan_timer_bar.png' },
        {id:'lan_timer_ctn', src: 'assets/letterati/ui/Landscape/Containers/lan_timer_ctn.png' },
        {id:'lan_answer_off', src: 'assets/letterati/ui/Landscape/Containers/lan_answer_off.png' },
        {id:'lan_answer_on', src: 'assets/letterati/ui/Landscape/Containers/lan_answer_on.png' },
        {id:'lan_answer_lose', src: 'assets/letterati/ui/Landscape/Containers/lan_answer_lose.png' },
        {id:'lan_choice_bg', src: 'assets/letterati/ui/Landscape/Containers/lan_choice_bg.png' },

        {id:'por_btn_word', src: 'assets/letterati/ui/Portrait/Buttons/por_choice.png' },
        {id:'por_btn_word_correct', src: 'assets/letterati/ui/Portrait/Buttons/por_choice_correct.png' },
        {id:'por_btn_word_wrong', src: 'assets/letterati/ui/Portrait/Buttons/por_choice_wrong.png' },
        {id:'por_ctn_question', src: 'assets/letterati/ui/Portrait/Containers/por_phrase.png' },
        {id:'por_timer_bar', src: 'assets/letterati/ui/Portrait/Containers/por_timer_bar.png' },
        {id:'por_timer_ctn', src: 'assets/letterati/ui/Portrait/Containers/por_timer_ctn.png' },
        {id:'por_answer_off', src: 'assets/letterati/ui/Portrait/Containers/por_answer_off.png' },
        {id:'por_answer_on', src: 'assets/letterati/ui/Portrait/Containers/por_answer_on.png' },
        {id:'por_answer_lose', src: 'assets/letterati/ui/Portrait/Containers/por_answer_lose.png' },
        {id:'por_choice_bg', src: 'assets/letterati/ui/Portrait/Containers/por_choice_bg.png' },

        {id:'gen_overlay', src: 'assets/letterati/ui/Backgrounds/gen_overlay.png' },

        {id:'htp0', src: 'assets/letterati/htp/htp_la_01.png' },
        {id:'htp1', src: 'assets/letterati/htp/htp_la_02.png' },
        {id:'htp2', src: 'assets/letterati/htp/htp_la_03.png' },
        {id:'htp3', src: 'assets/letterati/htp/htp_la_04.png' },
        {id:'htp4', src: 'assets/letterati/htp/htp_la_05.png' },
        {id:'htp5', src: 'assets/letterati/htp/htp_la_06.png' },

    ],
    audio:[
        {id:'bgm', mp3: "assets/letterati/bgm/bgm.mp3", ogg: "assets/letterati/bgm/bgm.ogg"},

        {id:'correct', mp3: "assets/letterati/sfx/correct.mp3", ogg: "assets/letterati/sfx/correct.ogg"},
        {id:'wrong', mp3: "assets/letterati/sfx/wrong.mp3", ogg: "assets/letterati/sfx/wrong.ogg"},
        {id:'ding', mp3: "assets/letterati/sfx/ding.mp3", ogg: "assets/letterati/sfx/ding.ogg"},
        {id:'tic', mp3: "assets/letterati/sfx/tic.mp3", ogg: "assets/letterati/sfx/tic.ogg"},
        {id:'toc', mp3: "assets/letterati/sfx/toc.mp3", ogg: "assets/letterati/sfx/toc.ogg"},

        {id:'button_press', mp3: "assets/letterati/sfx/button_sfx.mp3", ogg: "assets/letterati/sfx/button_sfx.ogg"},
    ],
}